import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import FormatCurrency from 'components/Common/FormatCurrency'
import { useReportSearchMapRowPrice } from 'components/Search/SearchResultsMap/SearchMapRowPrices'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import CruisePriceFromLabel from 'components/Cruises/Common/CruisePriceFromLabel'
import CruisePriceSaveUpCaption from 'components/Cruises/Common/CruisePriceSaveUpCaption'
import CruisePromotionPriceUnit from 'components/Cruises/Common/CruisePromotionPriceUnit'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import type { CruiseOnlyOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruiseCabinTypeLabels from 'hooks/Cruise/useCruiseCabinTypeLabels'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import Caption from 'LuxKit/Typography/Caption'
import Heading from 'LuxKit/Typography/Heading'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import { useCallback, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
interface Props {
  view: CruiseOnlyOfferView
}

function CruiseSearchTilePricing({ view }: Props) {
  const intl = useIntl()
  const cabinTypeLabels = useCruiseCabinTypeLabels()
  const {
    lowestPrice,
    memberLowestPrice,
    memberPriceType,
    discountPills,
    cabinCategory,
  } = view

  const promotionalPrice = lowestPrice.promotionalPrice
  const perPersonPrice = promotionalPrice?.perPersonPrice
  const hasPerPersonPrice = !!perPersonPrice
  useReportSearchMapRowPrice(perPersonPrice)

  const showModal = useContext(ModalContext)

  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  const twinShareLabel = intl.formatMessage({
    id: 'Zez7WNfVlG415oswa9hq',
    defaultMessage: 'Twin Share',
  })

  return <Group direction="vertical" gap={8}>
    <div>
      {promotionalPrice && <>
        <PriceRowPriceCaption>
          <CruisePriceFromLabel
            promotion={promotionalPrice.promotion}
            cabinType={cabinTypeLabels[cabinCategory.toLowerCase()] ?? cabinCategory}
          />
        </PriceRowPriceCaption>
        {hasPerPersonPrice ? <>
          <Caption variant="medium" colour="success-dark">
            <FormattedMessage
              id="01ZsUhS60i_gK_k4VanJ"
              defaultMessage="{price}/person"
              
              values={{
                price: <Heading as="span" variant="heading4" colour="success-dark">
                  <FormatCurrency value={perPersonPrice} />
                </Heading>,
              }}
            />
          </Caption>
          <Caption variant="medium" colour="light-foreground-alt">
            <FormatCurrency value={promotionalPrice.total} />&nbsp;
            <CruisePromotionPriceUnit promotion={promotionalPrice.promotion} />
          </Caption>
        </> : <LuxPlusPriceStack size="L" price={promotionalPrice.total} saleUnit={promotionalPrice.type} />}
      </>}
      {!promotionalPrice && <>
        <PriceRowPriceCaption><CruisePriceFromLabel /></PriceRowPriceCaption>
        <Group direction="horizontal" gap={4} verticalAlign="end">
          <LuxPlusPriceStack
            size="L"
            price={lowestPrice.primaryPrice.total}
            memberPrice={memberLowestPrice?.primaryPrice.total}
            saleUnit={lowestPrice.primaryPrice.type}
            mode={memberPriceType === 'STANDARD_PRICE' ? 'member-only' : undefined}
          />
        </Group>
        {lowestPrice.secondaryPrice && <PriceRowCaption>
          <FormattedMessage
            id="tS3bNBvwd_j1ZcVYvSzQ"
            defaultMessage="{price} /{priceType} · {twinShare}"
            
            values={{
              price: <FormatCurrency value={lowestPrice.secondaryPrice.total} />,
              priceType: lowestPrice.secondaryPrice.type,
              twinShare: twinShareLabel,
            }}
          />
        </PriceRowCaption>}
      </>}
      {!promotionalPrice && !lowestPrice.secondaryPrice && <PriceRowCaption>{twinShareLabel}</PriceRowCaption>}
      <PriceRowTaxesAndFees />
      {!lowestPrice.secondaryPrice && promotionalPrice && !!discountPills && discountPills.discountPrice > 0 && <CruisePriceSaveUpCaption
        size="M"
        discountAmount={discountPills.discountPrice}
        discountPercentage={discountPills.discountPercentage}
        onInfoIconClick={openDiscountTermsAndConditionsModal}
      />}
      {!lowestPrice.secondaryPrice && !promotionalPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
        size="M"
        originalValue={discountPills.price}
        discountPercentage={discountPills.discountPercentage}
        onInfoIconClick={openDiscountTermsAndConditionsModal}
      />}
    </div>
    <div>
      <PriceRowAgentHubCommission
        offerId={view.offer.id}
        offer={view.offer}
        productType={view.offer.productType}
      />
    </div>
  </Group>
}

export default CruiseSearchTilePricing
